import { Plugin } from 'vue'
import ElementDdExtension from './element-dd-extension'

declare module 'vue' {
  interface ComponentCustomProperties {
    $messaging: ElementDdExtension
  }
}

export default {
  install(app) {
    app.config.globalProperties.$messaging = new ElementDdExtension()
  },
} as Plugin
